import PostThread from './PostThread';
export default PostThread;
